import React from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"

import "./MenuItem.css"

export const MenuItemActu = ({ text, className, onClick, isActive }) => {
  const classNames = isActive ? `${className} active` : className
  return (
    <li className={classNames}>
      <a onClick={onClick}>{text}</a>
    </li>
  )
}

export const MenuItemAnchor = ({ anchor, text, className, onClick }) => {
  return (
    <li className={className}>
      <AnchorLink href={anchor} onClick={onClick}>
        {text}
      </AnchorLink>
    </li>
  )
}

export const MenuItemLogo = ({ anchor, logo, className, onClick }) => {
  return (
    <li className={className}>
      <AnchorLink href={anchor} onClick={onClick}>
        <img src={logo} />
      </AnchorLink>
    </li>
  )
}

export const MenuItemLink = ({ url, text, className, onClick }) => {
  return (
    <li className={className}>
      <a href={url} target="_blank" onClick={onClick}>
        {text}
      </a>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/Components/MenuItem/MenuItem.js